/**
 * SoundEffectsPage Component
 *
 * Main page for AI sound effect generation.
 * Supports Text-to-Audio (T2A) and Video-to-Audio (V2A) generation.
 */

import { memo } from 'react';
import { SfxGenerationPanel } from '../components/sound-effects';

export const SoundEffectsPage = memo(function SoundEffectsPage() {
  return (
    <main
      className="w-full max-w-4xl mx-auto px-3 sm:px-6 lg:px-8 py-4 sm:py-8"
      data-testid="sound-effects-page"
    >
      <SfxGenerationPanel />
    </main>
  );
});

export default SoundEffectsPage;
